<script setup lang="ts">
import type { ModelKey } from '~/features/my-wallet/constants/my-wallet'
import type { ModelTagVariant } from '~/features/my-wallet/types/receiving-model'
import { useI18n } from 'vue-i18n'

interface Props {
  model: ModelKey
  variant?: ModelTagVariant
}

withDefaults(defineProps<Props>(), {
  variant: 'filled',
})

const { t } = useI18n()
</script>

<template>
  <span class="model-tag" :class="[`-${variant}`, `-model-${model.toLowerCase()}`]">
    {{ t('my_wallet.models.tag', { model }) }}
  </span>
</template>

<style scoped lang="scss">
@use '../styles/model-tones' as tones;

.model-tag {
  @apply inline-flex items-center h-6 px-3 rounded-full whitespace-nowrap flex-shrink-0;
  @apply fonts-body-small-bold;

  &.-filled {
    @include tones.filled-tone-modifiers(('model-c', 'model-b', 'model-a'));
  }

  &.-outline-strong {
    @apply border-2 border-neutral-low-dark text-neutral-low-dark;
  }

  &.-outline-muted {
    @apply border-2 border-brand-primary-light text-brand-primary-light;
  }
}
</style>
